import type { ProviderGetImage } from '@nuxt/image'

export const getImage: ProviderGetImage = (src, { modifiers = {} } = {}) => {
  const startsWithHttp = src.startsWith('http')

  if (
    src !== '/croppa_undefined'
    && (!startsWithHttp || !src.includes('/storage/'))
  ) {
    return { url: src }
  }

  const { height, width } = modifiers

  const url = croppa(startsWithHttp ? src : undefined, width, height)

  return {
    url: url || makePlaceholder(width, height),
  }
}

export function makePlaceholder(
  width?: number | string,
  height?: number | string,
) {
  if (!width && !height) {
    return 'https://placehold.co/300x300'
  }

  const pld = ['https://placehold.co/']

  if (width) {
    pld.push(width.toString())
  }

  if (width && height) {
    pld.push('x')
  }

  if (height) {
    pld.push(height.toString())
  }

  return pld.join('')
}

function croppa(
  url?: string,
  width?: number | string,
  height?: number | string,
) {
  if (!url) {
    return undefined
  }

  if (!width && !height) {
    return url
  }

  const extension = url.split('.').pop()

  if (!extension) {
    return url
  }

  const path = url.slice(0, -extension.length - 1)
  const witdthStr = width || '_'
  const heightStr = height || '_'
  const croppedUrl = `${path}-${witdthStr}x${heightStr}.${extension}`

  return croppedUrl
}
